import {
  Customer as GqlGeneratedCustomer,
  DirectorInfo as GqlGeneratedDirectorInfo,
  GetCustomerChangeLogQuery,
  GetCustomerOptionsQuery,
  RiskMonitoringRemarks as GqlGeneratedRiskMonitoringRemarks,
  RiskRecommendationType,
} from "../graphql/generated";
import { toHumanReadable } from "../utils/string.ts";

export type Customer = Omit<
  GqlGeneratedCustomer,
  "hasGeneralLimit" | "pic" | "lateChargeFee"
> & {
  hasGeneralLimit?: boolean;
  pic?: Omit<Customer, "lateChargeFee">[] | null;
};

export type CustomerOption = GetCustomerOptionsQuery["customers"]["data"][0];

export type CustomerChangeLog =
  GetCustomerChangeLogQuery["customerChangeLog"][0];

export type DirectorInfo = GqlGeneratedDirectorInfo;

export type RiskMonitoringRemarks = GqlGeneratedRiskMonitoringRemarks;

export const toHumanReadableCustomerRiskRecommendation = (
  value: RiskRecommendationType | null | undefined
): string | undefined => {
  if (!value) {
    return;
  }
  switch (value) {
    case RiskRecommendationType.Top7:
      return "TOP 7 Hari";
    case RiskRecommendationType.Top14:
      return "TOP 14 Hari";
    case RiskRecommendationType.Cbd:
      return "CBD";
    default:
      return toHumanReadable(value);
  }
};

export const riskRecommendationOptions = Object.values(
  RiskRecommendationType
).map((item) => ({
  value: item,
  label: toHumanReadableCustomerRiskRecommendation(item),
}));
